// Borrowed from https://github.com/Aminadav/react-useStateRef/blob/master/index.ts

import {useCallback, useRef, useState, SetStateAction, Dispatch} from 'react';

interface ReadOnlyRefObject<S> {
   readonly current: S;
}

type UseStateRefValue<S> = [S, Dispatch<SetStateAction<S>>, ReadOnlyRefObject<S>];

const isFunction = <S>(setStateAction: SetStateAction<S>): setStateAction is (prevState: S) => S => typeof setStateAction === 'function';

const useStateRef = <S>(initialState?: S | (() => S)): UseStateRefValue<S> => {
   const [state, setState] = useState(initialState);
   const ref = useRef(state);

   const dispatch: typeof setState = useCallback((setStateAction: any) => {
      ref.current = isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;
      setState(ref.current);
   }, []);

   return [state, dispatch, ref];
};

export default useStateRef;